import { render, staticRenderFns } from "./AnswersView.vue?vue&type=template&id=2b6132d8&scoped=true&"
import script from "./AnswersView.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnswersView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6132d8",
  null
  
)

export default component.exports